import { Link } from "react-router-dom";
import { BrandIcon } from "../BrandLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const NAVY = "#1B2A41";
export const GOLD = "#E0A526";
export const ETAPAS = ["Consentimiento", "WhatsApp", "Documento", "Selfie", "Tus datos", "Listo"];
const col = (brand) => brand.color || NAVY;
export const acento = (brand) => (col(brand).toUpperCase() === NAVY ? GOLD : col(brand));

export const BrandMark = ({ brand, size = "h-10 w-10", texto = "text-lg" }) => (
  <div className="flex items-center gap-3 min-w-0">
    {brand.tiene_logo ? (
      <img src={`${API}/public/k/${brand.slug}/logo`} alt={brand.nombre} className={`${size} object-contain bg-white rounded-xl p-1 shadow-sm`} data-testid="kyc-brand-logo" />
    ) : (
      <span className={`${size} rounded-xl grid place-items-center font-semibold text-white shrink-0`} style={{ background: col(brand) }} data-testid="kyc-brand-initial">{(brand.nombre || "?").slice(0, 1)}</span>
    )}
    <span className={`font-semibold ${texto} text-slate-900 truncate`} data-testid="kyc-brand-name">{brand.nombre}</span>
  </div>
);

const Stepper = ({ etapa, brand }) => (
  <div className="px-5 pb-3" data-testid="kyc-progress">
    <div className="flex gap-1.5" aria-hidden>
      {ETAPAS.map((e, i) => (
        <span key={e} className="h-1.5 flex-1 rounded-full transition-colors duration-500" style={{ background: i < etapa ? acento(brand) : "#E2E8F0" }} />
      ))}
    </div>
    <p className="mt-2 text-xs text-slate-500" data-testid="kyc-paso">
      Paso {etapa} de {ETAPAS.length} · <span className="font-semibold text-slate-800">{ETAPAS[etapa - 1]}</span>
    </p>
  </div>
);

export const KycShell = ({ brand, etapa, pantalla, children }) => (
  <div className="kyc-ui min-h-[100dvh] bg-white flex flex-col" data-testid="kyc-shell"
    style={{ "--kyc-btn-bg": brand.color_boton2 ? `linear-gradient(135deg, ${brand.color_boton || col(brand)}, ${brand.color_boton2})` : (brand.color_boton || col(brand)) }}>
    <header className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-slate-100" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <div className="px-5 py-3 max-w-xl mx-auto w-full"><BrandMark brand={brand} /></div>
      {etapa && <div className="max-w-xl mx-auto w-full"><Stepper etapa={etapa} brand={brand} /></div>}
    </header>
    <main key={pantalla} className="kyc-in flex-1 w-full max-w-xl mx-auto px-5 pt-8 pb-8">{children}</main>
    <footer className="border-t border-slate-100 py-4 px-5 text-xs text-slate-500 flex items-center justify-center gap-2" style={{ paddingBottom: "max(1rem, env(safe-area-inset-bottom))" }} data-testid="kyc-footer">
      <BrandIcon className="h-4 w-4" testId="kyc-footer-icon" />
      Verificación segura por IntiCheck ·
      <Link to="/privacidad" target="_blank" className="underline text-slate-700" data-testid="kyc-privacy-link">Aviso de privacidad</Link>
    </footer>
  </div>
);

export const BigButton = ({ color, className = "", ...props }) => (
  <button
    {...props}
    className={`w-full min-h-[56px] rounded-2xl text-white text-base font-semibold px-6 shadow-sm transition-[opacity,transform] duration-150 disabled:opacity-40 active:scale-[0.98] ${className}`}
    style={{ background: `var(--kyc-btn-bg, ${color || NAVY})` }}
  />
);

export const GhostButton = ({ className = "", ...props }) => (
  <button {...props} className={`w-full min-h-[52px] rounded-2xl border border-slate-300 text-slate-800 text-base font-semibold px-6 bg-white transition-transform active:scale-[0.98] ${className}`} />
);

export const StepTitle = ({ paso, title, children }) => (
  <div className="space-y-2 mb-6">
    {paso && <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{paso}</p>}
    <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
    {children && <p className="text-[15px] text-slate-600 leading-relaxed">{children}</p>}
  </div>
);
